import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {SimulationSession} from '../data/SimulationSession';
import {SimulationSessionProvider} from '../data/SimulationSessionProvider';
import {Router} from '@angular/router';

@Component({
  selector: 'app-numbers-overview',
  templateUrl: './numbers-overview.component.html',
  styleUrls: ['./numbers-overview.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NumbersOverviewComponent implements OnInit {

  simulationSession!: SimulationSession;

  constructor(private simulationSessionProvider: SimulationSessionProvider, private router: Router) { }

  ngOnInit(): void {
    this.simulationSession = this.simulationSessionProvider.getSimulationSession();
  }

  public goBack() {
    this.router.navigate(['/startSimulation'], { state: { step: 3 }});
  }

  public goResults() {
    this.router.navigate(['/resultsOverview']);
  }
}
